export class email{
    
    constructor(
        public correo: string
    ){

    }
}